import { CurrentEnvironment } from '@src/components/CurrentEnvironment';
import { ErrorHandler } from '@src/components/ErrorHandler';
import { Header } from '@src/layouts/default/Header';
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';

import { Main } from './Main';

/**
 * Layout
 *
 * Glues together the various pieces of the layout.
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export function Layout(props) {
  const { children } = props;

  const stickyRef = useRef(null);

  return (
    <ErrorHandler location="src/layouts/default/Layout.jsx">
      <motion.div
        animate="open"
        initial={{ opacity: 0 }}
        variants={{
          closed: { opacity: 0 },
          open: { opacity: 1 },
        }}
      >
        <div className="app-layout" ref={stickyRef} style={{ height: '100%', position: 'relative' }}>
          <CurrentEnvironment />
          <Header stickyRef={stickyRef} />
          <Main>{children}</Main>
        </div>
      </motion.div>
    </ErrorHandler>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};
